import {NullableKeys} from '@fl/cmsch-fe-library';

import {CreatePermission} from 'api/gen/CreatePermission';

/** Form name used by the permission modal. */
export const createOrUpdatePermissionFormName = 'permissions';

/** Admin permission-form values type. */
export interface CreateOrUpdatePermissionFormValues {
    /** Permission action name. */
    actionName: string;
    /** Permission code. */
    code: string;
    /** Optional permission comment. */
    comment: string;
    /** Controller name. */
    controllerName: string;
    /** Selected discriminator id. */
    discriminatorId: number;
    /** Whether the permission is enabled for users. */
    userEnable: boolean;
}

/** Initial values for the permission form. */
export const createOrUpdatePermissionFormValues: NullableKeys<CreatePermission> = {
    actionName: '',
    code: '',
    comment: '',
    controllerName: '',
    discriminatorId: null,
    userEnable: false,
};
